export enum NotifTypes {
    VCC_LAUNCH = "VCC Incident Model Launch",
  }

export enum NotifMediums {
    EMAIL = "Email"
}
  